var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"7","stroke":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"8","r":"6.5","fill":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }